import { render, staticRenderFns } from "./RWidgetSimple.vue?vue&type=template&id=242c35c4&scoped=true&"
import script from "./RWidgetSimple.vue?vue&type=script&lang=js&"
export * from "./RWidgetSimple.vue?vue&type=script&lang=js&"
import style0 from "./RWidgetSimple.vue?vue&type=style&index=0&id=242c35c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242c35c4",
  null
  
)

export default component.exports